<div class="phone-input-wrapper" (click)="focusInput()">
	<ngx-mat-input-tel
		#telInput
		[formControl]="phoneControl">
	</ngx-mat-input-tel>
</div>
